// extracted by mini-css-extract-plugin
module.exports = {"light":"Copyright-module--light--3nTsf","dark":"Copyright-module--dark--W8ZZ6","copyright":"Copyright-module--copyright--1ariN"};